var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"flat":"","tile":""}},[_c('v-card-text',[_c('add-tracking',{attrs:{"issue":_vm.issue}})],1),_c('v-card-text',[_c('tracking-list',{attrs:{"issue":_vm.issue}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }